import { useMemo } from "react";
import type {
  MSPInformation,
  UserContact,
  Address,
  Subscription,
} from "../features/common/types";

export const useMSPCompanyData = (msp: MSPInformation | null) => {
  const companyContact = useMemo(
    () => msp?.mspContacts?.find((c) => c.contact?.contact_type === "company"),
    [msp]
  );
  const companyAddress: Address | undefined =
    companyContact?.contact?.addresses?.[0];
  const contacts: UserContact[] = msp?.mspContacts ?? [];
  const subscriptions: Subscription[] = msp?.mspSubscriptions ?? [];
  return { companyAddress, contacts, subscriptions } as const;
};
